import script from "./PolicyBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyBuilder.vue?vue&type=style&index=0&id=9ca0e426&lang=css"

const __exports__ = script;

export default __exports__